import { render, staticRenderFns } from "./AlumniImportType.vue?vue&type=template&id=01be155d&"
import script from "./AlumniImportType.vue?vue&type=script&lang=js&"
export * from "./AlumniImportType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports